import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteWorkspaceMutationVariables = Types.Exact<{
  input: Types.DeleteWorkspaceInput;
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace?: { __typename?: 'DeleteWorkspacePayload', workspace?: { __typename?: 'Workspace', id: string, name: string } | null } | null };


export const DeleteWorkspace = /*#__PURE__*/ gql`
    mutation DeleteWorkspace($input: DeleteWorkspaceInput!) {
  deleteWorkspace(input: $input) {
    workspace {
      id
      name
    }
  }
}
    ` as unknown as DocumentNode<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

          

          export const useDeleteWorkspaceMutation = (options?:MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) => useMutation(DeleteWorkspace, options);
          

          export type DeleteWorkspaceMutationOptions = MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

          

          export type DeleteWorkspaceMutationResult = ReturnType<typeof useDeleteWorkspaceMutation>[1];

          
